{
  "version": 1,
  "asset_id": "ddee51aa-ccd1-409e-8055-6f0f4361d678",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ddee51aa-ccd1-409e-8055-6f0f4361d678/destination-roofing-galvalume-metal-roof-inverness-fl-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ddee51aa-ccd1-409e-8055-6f0f4361d678/destination-roofing-galvalume-metal-roof-inverness-fl-480w.webp",
  "original_filename": "destination-roofing-galvalume-metal-roof-inverness-fl-480w.webp",
  "size": 47526,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:27Z"
}
